import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import PdfViewer from "../components/PdfViewer";

import CALIBER_PDF from '../images/CamScanner 01.06.2026 12.00.pdf';

const Caliber = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Helmet>
        <title>{t("caliber")} - Gordito Plus</title>
      </Helmet>
      <PdfViewer src={CALIBER_PDF} title={t("caliber")} />
    </div>
  );
};

export default Caliber;
